<iframe #element [src]="src" height="100%" width="100%"></iframe>
